import React from 'react';

interface CategorySelectProps {
  categories: string[];
  selectedCategories: string[];
  onToggle: (category: string) => void;
}

const CategorySelect: React.FC<CategorySelectProps> = ({
  categories,
  selectedCategories,
  onToggle
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {categories.map((category) => (
        <button
          key={category}
          onClick={() => onToggle(category)}
          className={`px-3 py-1.5 rounded-full text-sm transition-colors ${
            selectedCategories.includes(category)
              ? 'bg-brand text-white'
              : 'bg-background text-content-secondary hover:text-content-primary'
          }`}
        >
          {category.split('-').map(word => 
            word.charAt(0).toUpperCase() + word.slice(1)
          ).join(' ')}
        </button>
      ))}
    </div>
  );
};

export default CategorySelect;